import styled from 'styled-components';

export const PlayerHeader = styled.div`
    height: 48px;
    padding: 0 0 0 20px;
    font-size: 13px;
    font-weight: 600;
    line-height: 48px;
    text-transform: uppercase;
    text-align: center;

    & img {
        display: inline-block;
        height: 80%;
        vertical-align: middle;
        margin-left: 2%;
    }
`;

export const PlayerMain = styled.div`
    border: 1px solid #8a8e92;
    border-radius: 4px;
`;

export const PlayerWrapper = styled.div`
    position: relative;
    vertical-align: middle;
    overflow: hidden;
    color: #2b2b2b;

    & #LM_iframe {
        z-index: 1000 !important;
    }

    & .ad-duration {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        bottom: 3px;
    }

    & .ad-wrap-info {
        position: absolute;
        left: 5%;
        bottom: 3px;
    }

    & .ad-type {
        position: absolute;
        right: 5%;
        bottom: 3px;
    }
`;
